import { Modal } from "antd";
import { FC } from "react";
import { useInventoryStore } from "../inventory.store";
import { InventoryForm } from "./inventory-form";

type Props = {};

export const InventoryModal: FC<Props> = () => {
  const { formState, closeInventoryModal } = useInventoryStore();
  return (
    <Modal
      destroyOnHidden
      open={formState.open}
      onCancel={closeInventoryModal}
      title={
        <div className="py-2">
          <h2 className="text-xl font-medium">
            {formState.viewMode
              ? "View Inventory Item"
              : formState.inventoryId
              ? "Edit Inventory Item"
              : "Create Inventory Item"}
          </h2>
        </div>
      }
      width={"60%"}
      footer={null}
    >
      <InventoryForm viewMode={formState.viewMode} />
    </Modal>
  );
};
